// src/presentation/app.routes.ts
import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guard/auth.guard';
import { GuestGuard } from '../core/guard/guest.guard';
import { ContentComponent } from '../shared/components/layout/content/content.component';
import { content, DASHBOARD } from '../shared/routes/routes';

export const REINITIALISATION = 'reinitialisation';
export const AUTH = 'auth';

export const routes: Routes = [
    {
        path: AUTH,
        loadChildren: () =>
            import('./pages/authentication/authentication.module').then(
                (m) => m.AuthenticationModule
            ),
  //      canActivate: [GuestGuard],
    },
    {
        path: REINITIALISATION,
        loadChildren: () =>
            import('./pages/password-reset/password-reset.module').then(
                (m) => m.PasswordResetModule
            ),
    },
    {
        path: '',
        component: ContentComponent,
        children: content,
        canActivate: [AuthGuard],
    },
    {
        path: '',
        redirectTo: DASHBOARD,
        pathMatch: 'full',
    },
    // { path: '**', component: NotFoundComponent }
];
